import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

import { ref } from 'vue';
const _withScopeId = n => (_pushScopeId("data-v-2ebad544"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "arrowContainer"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "indicator"
};
const _hoisted_5 = ["src", "onClick"];
const _hoisted_6 = {
  class: "slogn"
};
const _hoisted_7 = {
  class: "subSlogn"
};
export default {
  __name: 'carousel',
  props: {
    topBanner: {
      default: () => [],
      type: Array
    },
    slogn: {
      default: "",
      type: String
    },
    subSlogn: {
      default: "",
      type: String
    },
    height: {
      default: "200px",
      type: String
    },
    interval: {
      default: 5000,
      type: Number
    },
    arrowLeft: {
      default: require("@/assets/images/carousel-white-left.png"),
      type: String
    },
    arrowRight: {
      default: require("@/assets/images/carousel-white-right.png"),
      type: String
    },
    indicatorDefaultImg: {
      default: require("@/assets/images/u11.svg"),
      type: String
    },
    indicatorActiveImg: {
      default: require("@/assets/images/u10.svg"),
      type: String
    }
  },
  setup(__props) {
    // name: 'carousel',

    let activeIndex = ref(0);
    let cardShow = ref(null);
    function arrowClick(val) {
      if (val === 'right') {
        cardShow.value.next();
      } else {
        cardShow.value.prev();
      }
    }
    function bannerChange(nowBannerIndex, prevBannerIndex) {
      activeIndex.value = nowBannerIndex;
    }
    function changeIndicator(index) {
      activeIndex.value = index;
      cardShow.value.setActiveItem(index);
    }
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_carousel, {
        height: __props.height,
        class: "carousel",
        interval: __props.interval,
        arrow: "never",
        trigger: "click",
        "indicator-position": "none",
        ref_key: "cardShow",
        ref: cardShow,
        onChange: bannerChange
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
          class: "carousel-Arrow",
          src: __props.arrowLeft,
          alt: "",
          onClick: _cache[0] || (_cache[0] = $event => arrowClick('left'))
        }, null, 8, _hoisted_2), _createElementVNode("img", {
          class: "carousel-Arrow",
          src: __props.arrowRight,
          alt: "",
          onClick: _cache[1] || (_cache[1] = $event => arrowClick('right'))
        }, null, 8, _hoisted_3)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.topBanner, (item, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "carousel-item-img",
              style: _normalizeStyle('background-image:url(' + item.src + ')')
            }, null, 4)]),
            _: 2
          }, 1024);
        }), 128)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.topBanner.length, (item, index) => {
          return _openBlock(), _createElementBlock("img", {
            src: index == _unref(activeIndex) ? __props.indicatorActiveImg : __props.indicatorDefaultImg,
            key: index,
            onClick: $event => changeIndicator(index),
            alt: ""
          }, null, 8, _hoisted_5);
        }), 128))]), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.slogn), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.subSlogn), 1)]),
        _: 1
      }, 8, ["height", "interval"])]);
    };
  }
};